import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarGrades,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function GradeFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedGrades =
    useTypedSelector(getSelectedFilters).selectedParams.selectedGrades;
  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const gradesOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'grades'
  );

  const handleChangeGrades = (grade: OptionType) => {
    dispatch(setCarGrades(handleChangeMultiSelect(grade, selectedGrades)));
    dispatch(setPage(1));
  };

  const handleClearGrades = () => {
    dispatch(setCarGrades([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Грейд"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelect
          options={gradesOptions}
          selectedOptions={selectedGrades}
          onChange={handleChangeGrades}
          onClear={handleClearGrades}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default GradeFilter;
